import React, { Component } from 'react';
import { connect } from 'react-redux'
import StickyFixedHeader from "../../../general/stickyHeader/stickyFixedHeader";
const stateManager = require('../../../../../utils/state/stateManager');
const menuCategoryAction = require('../../../../../utils/state/actions/menuCategory/menuCategoryAction');

class Categories extends Component 
{
    render()
    {
        return  <StickyFixedHeader>
                    <div style={{
                                background:`var(--menu-categories-background-color)`, 
                                paddingLeft:'60px', paddingRight:'60px',
                                paddingTop:'15px', paddingBottom:'15px',
                                borderTop:`var(--menu-categories-top-border)`,
                                borderBottom: `var(--menu-categories-bottom-border)`,
                                display:'flex',
                                overflowY:'hidden',
                                }} 
                    className="invisible-scrollbar">
                    {this.renderMenuCategories()}
                    </div>
                </StickyFixedHeader>
    }

    renderMenuCategories()
    {
        var state = stateManager.getStore().getState();
        var menu = state.currentMenu;
        
        var childComponents = [];
        if (menu == null || menu.categories.length <= 0)
            return childComponents;

        if (this.props.currentMenuCategoryIndex == -1)
        {
            stateManager.getStore().dispatch(menuCategoryAction.createAction(0));
            return;
        }
        for (var index = 0; index < menu.categories.length; index++)
        {
            if (menu.categories[index].items.length <= 0)
                continue;
                
            let background = null;
            let color = null;
            let border = null;
            let borderRadius = null;
            let currentIndex = index;

            let htmlId = `menu-category-toolbar-${index}`;

            if (currentIndex == this.props.currentMenuCategoryIndex)
            {
                background = `var(--menu-selectedCategory-background-color)`;
                color = `var(--menu-selectedCategory-font-color)`;
                borderRadius = "20px" 
            }

            childComponents.push(<div id={htmlId} style={{
                                                border: border,
                                                borderRadius: borderRadius,
                                                background:background, 
                                                color: color,
                                                paddingLeft:'50px',
                                                paddingRight:'50px',
                                                paddingTop:'10px',
                                                paddingBottom:'10px',
                                                marginRight:'10px', 
                                                whiteSpace:'nowrap'}}
                                    
                                    onClick={()=>
                                    {
                                        if (currentIndex == this.props.currentMenuCategoryIndex)
                                            return;
                                        
                                        this.props.onClick(currentIndex);
                                        stateManager.getStore().dispatch(menuCategoryAction.createAction(currentIndex));
                                    }}
                                    >
                                    {menu.categories[index].caption}

                                    
                                </div>)
        }

        return childComponents;
    }
    
}

const mapStateToProps = state => 
{
    return { 
        currentMenuCategoryIndex: state.currentMenuCategoryIndex,
    }
}

export default connect(mapStateToProps)(Categories)